import styles from './Account.module.css';

// Maps an account / subscription / invoice status to a coloured pill.
// Colour language: 🟢 Active · 🟡 Trial · 🔵 Pending launch · 🔴 Cancelled.
const MAP = {
  // Account-level
  active:        { cls: 'badgeGreen', label: 'Active' },
  trialing:      { cls: 'badgeAmber', label: 'Trial' },
  trial_pending: { cls: 'badgeBlue',  label: 'Pending launch' },
  inactive:      { cls: 'badgeMuted', label: 'No active plan' },
  canceled:      { cls: 'badgeRed',   label: 'Cancelled' },
  // Trial-level
  pending:       { cls: 'badgeBlue',  label: 'Pending launch' },
  ended:         { cls: 'badgeMuted', label: 'Ended' },
  // Invoice-level
  paid:          { cls: 'badgeGreen', label: 'Paid' },
  open:          { cls: 'badgeAmber', label: 'Open' },
  failed:        { cls: 'badgeRed',   label: 'Failed' },
};

export default function StatusBadge({ status, label }) {
  const cfg = MAP[status] || { cls: 'badgeMuted', label: status || 'Unknown' };
  return (
    <span className={`${styles.badge} ${styles[cfg.cls]}`}>
      <span className={styles.badgeDot} />
      {label || cfg.label}
    </span>
  );
}
